import page from 'modules/ab-page-js';
import domify from 'domify';
import container from 'modules/section-content';
import splash from './terms-page.pug';
import metadata from './metadata.json';

export default function register() {
  page('/web-terms', render);
  page('/terms', () => page.redirect('/web-terms'));
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}



// WEBPACK FOOTER //
// ./src/pages/terms/terms.js